// extracted by mini-css-extract-plugin
export default {"imageFallbackSmall":"MzXeLS"};